const mapToLatinCharacters = (char) => {
        const latinMap = {
                    'à': 'a',
                    'á': 'a',
                    'â': 'a',
                    'ã': 'a',
                    'ä': 'a',
                    'ç': 'c',
                    'è': 'e',
                    'é': 'e',
                    'ê': 'e',
                    'ë': 'e',
                    'ì': 'i',
                    'í': 'i',
                    'î': 'i',
                    'ï': 'i',
                    'ñ': 'n',
                    'ò': 'o',
                    'ó': 'o',
                    'ô': 'o',
                    'õ': 'o',
                    'ö': 'o',
                    'š': 's',
                    'û': 'u',
                    'ú': 'u',
                    'ü': 'u',
                    'ù': 'u',
                    'ý': 'y',
                    'ÿ': 'y',
                    'ž': 'z',
                    'æ': 'ae',
                    'œ': 'oe',
                    'ß': 'ss'
                };
        return latinMap[char] || char;
};

module.exports = function formatStandardSlug(name) {
        return name.toLowerCase()
            .trim()
            .replace(/&+/g, ' ')
            .replace(/\s+/g, '-')
            .replace(/./g, mapToLatinCharacters)
            .replace(/[^a-z0-9-]+/g, '');
};




// WEBPACK FOOTER //
// ./js/format-slug.js